import { SpexNode } from '../types/playbook.type'
import { NodeView } from '../../shared/types/api/playbook.type'
import { nodeLabelStyle } from '../customNodes/TextNode'
import { measureText } from './measureText'

export const buildNode = (
  id: string,
  x: number,
  y: number,
  data: any,
  type?: string,
  view: NodeView = 'plain',
): SpexNode => {
  const labelWidth = measureText(data.label, nodeLabelStyle)

  let measured

  measured = {
    width: labelWidth ? Math.round(labelWidth + 110) : 300,
    height: 60,
  }
  let { width, height } = measured

  if (view === 'chart') {
    measured = undefined
    width = 500
    height = 200
  } else if (view === 'map') {
    measured = undefined
    width = 550
    height = 300
  }

  return {
    id,
    type,
    view,
    data: { ...data },
    position: { x, y },
    measured: measured,
    width,
    height,
  }
}
